/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import Relay from 'react-relay';
import PagingGrid, {defaultPageSize, processPagingParams} from '../fw/PagingGrid.react';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';

import urlMapping from '../app/URLMapping';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'flowAdd.title', 'defaultMessage': 'Adding Flows'},
    search: {id: 'flowAdd.search', 'defaultMessage': 'Search'}
});

interface FlowAddProps {
    intl: IntlShape;
    relay: object;
    user: User;
}

class FlowAdd extends React.Component<FlowAddProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'flows';

    constructor() {
        super();
    }

    onChange = (event) => {
        let lastValue = event.target.value;

        /* wait 250 ms after last change */
        if (this.delayTimeout) {
            clearTimeout(this.delayTimeout);
        }

        this.delayTimeout = setTimeout(() => {
            this.props.relay.setVariables({
                searchName: lastValue
            });
        }, 250);
    };

    getUrl = (item) => {
        return urlMapping.getUrl(types[this.typeName], 'create-step-1', {
            organisation_id: this.props.user.organisation.realId,
            id: item['id']
        });
    };

    render() {
        const {flowDefsToAdd} = this.props.user;
        const list = flowDefsToAdd;
        let type = types[this.typeName];

        return (
            <AppPanel  breadcrumbParams={[
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                    <h1 className="title-underline"><FormattedMessage defaultMessage="Choose Flow to add" id="flow.add.chooseOne"/></h1>

                    <div className="input-group" style={{maxWidth: '200px', marginBottom: '1em'}}>
                        <input className="form-control" name="search" onChange={this.onChange} placeholder={this.props.intl.formatMessage(messages.search)} type="text" />
                        <span className="input-group-addon" id="basic-addon2"><span className="fa fa-search"/></span>
                    </div>

                    <PagingGrid
                        columns={{
                            'name': {},
                            'description': {},
                        }}
                        edges={list}
                        getUrl={this.getUrl}
                        metadata={type}
                        pageInfo={list.pageInfo}
                        parent={this.props.user}
                        relay={this.props.relay}
                        urlMapping={urlMapping} />
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(FlowAdd), (props) => {
    return props.user.organisation;
}), {
    initialVariables: {
        organisationId: '',
        first: defaultPageSize,
        after: null,
        before: null,
        last: null,
        searchName: '',
    },
    prepareVariables (variables) {
        processPagingParams(variables);

		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                },
                flowDefsToAdd(first: $first, after: $after, before: $before, last: $last) {
                    edges {
                        node {
                            id,
                            name,
                        }
                    },
                    pageInfo {
                        hasNextPage,
                        hasPreviousPage,
                        startCursor,
                        endCursor
                    }

                }
            }
        `,
    },
});
